var RaphaelView = require('raphaelItemView'),
    _ = require('underscore');

/*
* Drag Event set on these.
* Note: don't need view -- just create wrapper for the Raphael element --
* if get rid of the events hash and go inline ( ... ? )
* */

module.exports = RaphaelView.extend({
    svgAttrs: {
        stroke: '#0F3CFF',
        fill: '#FFF',
        'fill-opacity': 1 //for IE8
    },
    nonHoverFill: '#FFF',
    hoverFill: '#92C5F4',
    CIRCLE_SIZE: 5,
    /*
    * Note: no render (see above)
    * */
    initialize: function(options) {

        var sv = options.shapeView,
            pt = options.pt,  //(could be model) -- this.oPos (don't need to pass in)

            el = sv.paper.circle( pt.x, pt.y, this.CIRCLE_SIZE )
                .attr( _.extend( this.svgAttrs, {cursor: pt.cursor} ) )
                .data('ptIndex', pt.id) // Note: used to identify when element clicked; associated w/pt from handleset array
                .data('shapeType', 'selectHandle');

        el.drag( sv.resizeMove, sv.resizeStart, sv.resizeEnd, sv, sv, sv );

        this.setElement(el);
        return this;

    },
    events: {
        'mouseover' : 'mouseover',
        'mouseout'  : 'mouseout'
    },
    mouseover: function () {
        this.el.attr('fill', this.hoverFill);
    },
    mouseout: function () {
        this.el.attr('fill', this.nonHoverFill);
    },
    onBeforeDestroy: function () {
        this.el.undrag(); //(not chained)
        this.el
            .unmouseover( this.mouseover )
            .unmouseout( this.mouseout );
        this.el.removeData().remove();
        this.remove(); //no children
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/selectSet/selectHandle.js
 ** module id = 196
 ** module chunks = 0
 **/